import type { ApiErrorResponse } from "@lib";
import type { AxiosError } from "axios";
import type { UseFormSetError } from "react-hook-form";
import type { VehicleFormSchema } from "../schemas";

export const handleBackendValidationErrors = (
	error: unknown,
	setError: UseFormSetError<VehicleFormSchema>
) => {
	const axiosError = error as AxiosError<{ error: ApiErrorResponse }>;

	const fieldsErrors = axiosError.response?.data?.error?.fieldsErrors;

	if (!fieldsErrors) {
		return;
	}

	// Converte "Plate" → "plate", "ModelYear" → "modelYear" etc.
	for (const [fieldName, messages] of Object.entries(fieldsErrors)) {
		const formField = (fieldName.charAt(0).toLowerCase() +
			fieldName.slice(1)) as keyof VehicleFormSchema;

		setError(formField, {
			type: "manual",
			message: (messages as string[])[0] ?? "Campo inválido",
		});
	}
};
